// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__akeZN","col":"styles_col__2bZW1"};